import { Bx } from '@curry-group/mui-curcuma';
import { faBan, faHourglassHalf } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

export interface IDeactivatedIconProps {
  title?: string;
}

export const DeactivatedIcon: React.FC<IDeactivatedIconProps> = ({ title = 'Inaktiv' }) => (
  <Bx
    component="span"
    title={title}
    aria-label={title}
    color="error.main"
    display="inline-block"
    position="relative"
    className="fa-layers"
  >
    <FontAwesomeIcon icon={faBan} />
    <FontAwesomeIcon
      icon={faHourglassHalf}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        fontSize: '0.55em',
      }}
    />
  </Bx>
);
